import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ISetBuildingRoomValues, StagingService } from '../../../new-information/services/staging.service';
import { IPlace } from '../../../components/spot-form-editor/commercial-rooms/commercial-rooms.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ImageService } from '../../../shared/services/image.service';

@Component({
  selector: 'app-sale-dialog',
  templateUrl: './sale-dialog.component.html',
  styleUrl: './sale-dialog.component.scss'
})
export class SaleDialogComponent implements OnInit {

  data = inject<{ place: IPlace, buildingId: number, floorId: number, roomTypeID: number }>(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<SaleDialogComponent>);
  selectedFile: File | null = null;
  selectedFileName = '';
  stagingService = inject(StagingService);
  imgService = inject(ImageService);
  pdfSrc = "data:application/pdf;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
  page = 1;
  imageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
  imgHover: boolean = false;
  reader: any;
  loadPlan: boolean = false;
  oneFlatDataSet1: {
    buildingRoomID?: number;
    fileTypeId: number | null;
    attachment: File | null;
    fileExtension?: 'pdf' | 'image' | null;
  } = {
      buildingRoomID: this.data.place.id,
      fileTypeId: null,
      attachment: null,
      fileExtension: null
    };

  form = new FormGroup({
    priceAmount: new FormControl<number | null>(null, Validators.required),
    saleDate: new FormControl<string | null>(null, Validators.required),
  });

  get saleDate(): FormControl<string | null> {
    return this.form.get('saleDate') as FormControl<string | null>;
  }

  toastService = inject(ToastrService);

  ngOnInit() {
    this.form.patchValue({
      priceAmount: this.data.place.priceAmount ?? null,
      saleDate: this.data.place.saleDate ?? null,
    });
    this.getPhoto(this.data.place.dbFileID);
  }

  closeDialog() {
    this.dialogRef.close(true);
  }


  handleFileInput(event: Event) {
    const file = (event.target as HTMLInputElement).files;
    if (!file?.length) return;
    this.oneFlatDataSet1.fileTypeId = 1;
    this.oneFlatDataSet1.attachment = file.item(0);
    this.reader = new FileReader();
    if (file[0].type === "image/png" || file[0].type === "image/jpeg") {
      this.oneFlatDataSet1.fileExtension = 'image';
      this.reader.onload = (event: any) => {
        this.imageUrl = event.target.result;
        this.imgHover = true;
      };
      this.loadPlan = true;
      this.reader.readAsDataURL(this.oneFlatDataSet1.attachment);
    }
    if (file[0].type === "application/pdf") {
      this.oneFlatDataSet1.fileExtension = 'pdf';
      this.reader.onload = (event: any) => {
        this.pdfSrc = event.target.result;
        this.imgHover = true;
      };
      this.loadPlan = true;
      this.reader.readAsDataURL(this.oneFlatDataSet1.attachment);
      this.oneFlatDataSet1.fileTypeId = 3;
    }
  }

  getPhoto(fileId: number) {
    if (fileId) {
      this.imgHover = true;
      this.imgService.getImage(fileId, false, 'Files/DownloadBuildingFile?fileId=').subscribe(
        (base64Image) => {
          this.imageUrl = base64Image;
          this.pdfSrc = base64Image;
          this.loadPlan = true;

          if (this.data.place.extension === 'pdf') {
            this.oneFlatDataSet1.fileExtension = 'pdf';
          } else if (this.data.place.extension === 'png' || this.data.place.extension === 'jpg' || this.data.place.extension === 'jpeg') {
            this.oneFlatDataSet1.fileExtension = 'image';
          } else {
            this.oneFlatDataSet1.fileExtension = null;
          }

          // if (typeof base64Image === 'string' && base64Image.startsWith('data:application/pdf')) {
          //   this.oneFlatDataSet1.fileExtension = 'pdf';
          // } else {
          //   this.oneFlatDataSet1.fileExtension = 'image';
          // }
        },
        (error) => {
          this.imageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
          this.pdfSrc = this.imageUrl; // Set fallback image for both imageUrl and pdfSrc
          this.loadPlan = false;
          // this.oneFlatDataSet1.fileExtension = null;
        }
      );
    } else {
      this.imgHover = false;
      this.imageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
      this.pdfSrc = this.imageUrl;
      this.loadPlan = false;
      // this.oneFlatDataSet1.fileExtension = null;
    }
  }

  zoommedPhoto: boolean = false;
  zoomPhoto() {
    this.zoommedPhoto = true;
  }

  confirm() {
    this.form.markAllAsTouched();
    if (this.form.invalid) return;

    const place = this.data.place;
    const priceAmount = Number(this.form.controls.priceAmount.value);
    const saleDate = this.form.controls.saleDate.value;

    const obj: ISetBuildingRoomValues = {
      priceAmount,
      saleDate: saleDate ?? undefined,
      buildingID: this.data.buildingId,
      buildingRoomID: place.id,
      roomTypeItemID: place.roomTypeItemID,
      entrance: place.entrance,
      floorID: this.data.floorId,
      placeNumber: place.placeNumber,
      area: place.area,
      roomTypeItemTitle: place.roomTypeItemTitle
    }

    this.stagingService.setBuildingRoomValues(obj).subscribe({
      next: () => {
        const attachment = this.oneFlatDataSet1.attachment;
        const fileTypeId = this.oneFlatDataSet1.fileTypeId;

        if (attachment && fileTypeId) {
          this.stagingService.insBuildingRoomFiles(place.id, fileTypeId, attachment).subscribe({
            next: () => {
              this.toastService.success('Данные и файл успешно сохранены');
              this.dialogRef.close(true);
            },
            error: () => {
              this.toastService.error('Данные сохранены, но файл загрузить не удалось');
            }
          });
          return;
        }

        this.toastService.success('Данные успешно сохранены');
        this.dialogRef.close(true);
      },
      error: () => {
        this.toastService.error('Ошибка при сохранении данных');
      }
    });
    // this.dialogRef.close({ confirmed: true, field1, field2, file: this.selectedFile });
  }


  deletePlan() {
    this.stagingService.removePlan(this.data?.place?.dbFileID).subscribe(
      _ => {
        this.toastService.success("Изменения сохранены!", "Успешно!");
        this.oneFlatDataSet1.attachment = null;
        this.oneFlatDataSet1.fileTypeId = null;
        this.oneFlatDataSet1.fileExtension = null;
        this.loadPlan = false;
      },
      (err: any) => {
        if (err.status == 500 || err.status == 0) {
          this.toastService.error(
            "К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!",
            "Ваши данные не сохранены!"
          );
        }
      }
    );
  }

}
